(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('SmootherMultiplier', SmootherMultiplier);

    SmootherMultiplier.$inject = ['$resource'];

    function SmootherMultiplier ($resource) {
        var resourceUrl =  'api/smoother-multipliers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
